import { render, staticRenderFns } from "./LabelDay.vue?vue&type=template&id=1275cae5&scoped=true&"
import script from "./LabelDay.vue?vue&type=script&lang=js&"
export * from "./LabelDay.vue?vue&type=script&lang=js&"
import style0 from "./LabelDay.vue?vue&type=style&index=0&id=1275cae5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275cae5",
  null
  
)

export default component.exports